import React from 'react'
import { Popover, MenuItem } from '@material-ui/core'
import { Icon } from '@iconify/react'

const SectionPopover = props => {
  const { openPopup, handleClosePopup, itemData } = props
  return (
    <Popover
      open={Boolean(openPopup)}
      anchorEl={openPopup}
      onClose={handleClosePopup}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
      sx={{
        width: 'auto',
        '& .MuiMenuItem-root': {
          px: 1,
          typography: 'body2',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          margin: '6px',
        },
      }}
      disabledArrow
    >
      {itemData.map((item, index) => (
        <MenuItem
          key={index}
          disabled={item.disabled}
          onClick={e => {
            e.stopPropagation()
            if (item.disabled) return
            item.action()
            handleClosePopup()
          }}
        >
          {item.icon && <Icon icon={item.icon} style={{ fontSize: 18 }} />}
          {item.text}
        </MenuItem>
      ))}
    </Popover>
  )
}

export default SectionPopover
